import apiClient from '../lib/api/client';

const apiOptions = {
  endpoint: process.env.REACT_APP_API_ENDPOINT
};

const client = new apiClient(apiOptions);
export default client;